package fr.arcplex.sooner.coherence

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import fr.arcplex.network.model.Branding
import fr.arcplex.network.model.CoherenceLabels
import fr.arcplex.network.model.CoherenceTheme

/**
 * Compose-owned branding holder: the port's [branding] values are applied here
 * and the views read them.
 */
object CoherenceThemeState {
    var theme by mutableStateOf(CoherenceTheme.DEFAULT)
        private set

    var labels by mutableStateOf(CoherenceLabels.DEFAULT)
        private set

    fun apply(branding: Branding) {
        theme = branding.theme
        labels = branding.labels
    }
}
